<template>
    <div>

        <div class="container-fluid border-bottom-light">
            <div class="col-sm-12 fs-largest darker py-3">
                <router-link to="/reservation" tag="span" class="pointer">
                    <i class="ico ico-arrow-left fs-larger"></i>
                    {{product.name}}
                </router-link>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data: function() {
            return {

            }
        },
        props:{
            product:{
                type: Object
            }
        },
        methods:{
        }
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Navigator.vue?171b9400